import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';

type ScenarioOption = {
  user_message: string;
};

type Props = {
  batch1Scenarios: ScenarioOption[];
  batch1Responses: string[];
  batch2Scenarios: ScenarioOption[];
  batch2Choices: string[];
  avoid: string;
  submitting: boolean;
  onFinalize: () => void;
  onReset: () => void;
};

export function ToneReviewStep({
  batch1Scenarios,
  batch1Responses,
  batch2Scenarios,
  batch2Choices,
  avoid,
  submitting,
  onFinalize,
  onReset,
}: Props) {
  return (
    <div className="space-y-4">
      <Card className="p-5 space-y-4 shadow-sm">
        <h3 className="text-lg font-semibold">Riepilogo rapido</h3>
        <div className="space-y-3">
          <div className="text-sm text-muted-foreground">Scelte iniziali</div>
          <ul className="space-y-2">
            {batch1Scenarios.map((s, idx) => (
              <li key={idx} className="rounded border border-border p-3">
                <div className="font-medium">{s.user_message}</div>
                <div className="text-muted-foreground mt-1">
                  Risposta del terapeuta: {batch1Responses[idx]}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <Separator />
        <div className="space-y-3">
          <div className="text-sm text-muted-foreground">Risposte scritte</div>
          <ul className="space-y-2">
            {batch2Scenarios.map((s, idx) => (
              <li key={idx} className="rounded border border-border p-3">
                <div className="font-medium">{s.user_message}</div>
                <div className="text-muted-foreground mt-1">
                  Opzione scelta: {batch2Choices[idx]}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <Separator />
        <div>
          <div className="text-sm text-muted-foreground mb-1">Cose da evitare</div>
          <p className="text-foreground whitespace-pre-wrap">{avoid || '(nessuna indicazione)'}</p>
        </div>
      </Card>
      <div className="flex gap-3 justify-end">
        <Button variant="outline" disabled={submitting} onClick={onReset}>
          Ricomincia
        </Button>
        <Button disabled={submitting} onClick={onFinalize} isLoading={submitting}>
          {submitting ? 'Sto imparando da te...' : 'Distilla tono'}
        </Button>
      </div>
    </div>
  );
}
